module.exports = __webpack_public_path__ + "media/images/home-illu-c787c33e70e41837f2930a3b504b6a2c.jpg";